import { AddressValue } from "$src/domain/core/AddressValue";
import { Geocode } from "$src/domain/map/GeoCode";
import type { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { inject, injectable } from "tsyringe";

@injectable()
export class ComputeGeocode {
    
    constructor(@inject(ServiceTokens.LocalityRepository) private localityRepository: ILocalityRepository) {}

    async execute(address: AddressValue): Promise<Geocode> {
        var geoCode = await this.localityRepository.geoCode( address);
        return geoCode;
    }
}

export const GeocodeToken = Symbol('GeocodeToken');    
